import { SEARCH_CONTACTS } from '../types'

export function doSearch(term) {
  return {
    type: SEARCH_CONTACTS,
    payload: { term },
  }
}
